import { queryOptions } from '@tanstack/react-query';
import { restaurantCategoryApi } from './restaurant-category-api';

/** Query-key factory + query-options for restaurant category reads. */
export const restaurantCategoryKeys = {
  all: ['restaurant-categories'] as const,
  details: () => [...restaurantCategoryKeys.all, 'detail'] as const,
  detail: (id: string) => [...restaurantCategoryKeys.details(), id] as const,
};

export const restaurantCategoryQueries = {
  detail: (id: string, enabled = true) =>
    queryOptions({
      queryKey: restaurantCategoryKeys.detail(id),
      queryFn: () => restaurantCategoryApi.detail(id),
      enabled: enabled && Boolean(id),
    }),
};
